import { useEffect, useState } from 'react';
import { DRAG_HOVER_EXPAND_DELAY_MS } from './constants';

export interface IUseSectionExpansionOptions {
  isDropTarget: boolean;
}

export interface ISectionExpansion {
  isExpanded: boolean;
  toggleExpanded: () => void;
}

// A collapsed section renders no grid, so a card dragged onto it has nowhere to preview into.
// Dwelling over the header opens it, and it stays open for the rest of the gesture - re-collapsing
// on leave would flap, since expanding shifts the page and moves the pointer onto another section.
export const useSectionExpansion = ({ isDropTarget }: IUseSectionExpansionOptions): ISectionExpansion => {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  useEffect(() => {
    if (!isDropTarget) return undefined;

    const dwell = setTimeout(() => setIsExpanded(true), DRAG_HOVER_EXPAND_DELAY_MS);

    return () => clearTimeout(dwell);
  }, [isDropTarget]);

  return { isExpanded, toggleExpanded: () => setIsExpanded((previous) => !previous) };
};
